import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8Zm0 31c119.846 0 217 97.154 217 217s-97.154 217-217 217S39 375.846 39 256 136.154 39 256 39Zm3.39 58.61c-17.855 0-32.029 13.446-32.029 31.302.006 17.478 14.177 30.88 32.03 30.88 17.846-.004 32.325-13.405 32.332-30.88 0-17.85-14.483-31.296-32.332-31.303zm-25.005 98.267V380h50.254V195.877Z" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "warning"}) } }